export const SET_LOADING = '@produto/SET_LOADING';
export const SET_QUERY_TYPE = '@produto/SET_QUERY_TYPE';
export const SEARCH_REQUEST = '@produto/SEARCH_REQUEST';
export const SEARCH_SUCCESS = '@produto/SEARCH_SUCCCESS';
export const SET_APPLICATION_MODE = "@app/SET_APPLICATION_MODE";

